import type { Worksheet } from "exceljs";

export const installMaxWidth = (worksheet: Worksheet) => {
  worksheet.columns.forEach((column) => {
    if (!column.eachCell) {
      return;
    }
    let maxLength = 0;
    column.eachCell({ includeEmpty: true }, (cell) => {
      const cellLength = String(cell.value).length;
      maxLength = Math.max(maxLength, cellLength);
      cell.border = {
        top: {
          style: "thin",
        },
        right: {
          style: "thin",
        },
        bottom: {
          style: "thin",
        },
        left: {
          style: "thin",
        },
      };
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
      cell.font = {
        ...cell.font,
      };
    });
    column.width = maxLength + 2;
  });
};
